export default __webpack_public_path__ + "static/media/user.b10882cc.svg";